import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";


const _base = "jwStudentRoll/";

// 申请毕业
export const applyGraduation = params => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "applyGraduation", {
           data: Qs.stringify(_params),
           method: "POST"
         });
       };

// 申请毕业核对信息
export const getRollGraduationVO = params => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "getRollGraduationVO", {
           data: _params,
           method: "GET"
         });
       };
// 学生 - 暂缓毕业申请列表
export const getSlowChangeList = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "getSlowChangeList", {
           data: _params,
           method: "GET",
         });
       };
// 学生 - 申请缓毕业
export const applySlowGraduation = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "applySlowGraduation", {
           data: _params,
           method: "POST",
         });
       };
// 学生 - 编辑缓毕业
export const editSlowChange = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "editSlowChange", {
           data: _params,
           method: "POST",
         });
       };
// 学生 - 详情缓毕业
export const getSlowChangeView = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "getSlowChangeView", {
           data: _params,
           method: "GET",
         });
       };

// 学生 - 获取学生信息
export const getSlowChangeRoll = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "getSlowChangeRoll", {
           data: _params,
           method: "GET",
         });
       };
// 学生 - 毕业生信息核对确认
export const verifyGraduateInfo = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "verifyGraduateInfo", {
           data: Qs.stringify(_params),
           method: "POST",
         });
       };
// 学生 - 撤销申请毕业
export const revokeGraduation = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "revokeGraduation", {
           data: _params,
           method: "POST",
         });
       };

// 根据当前学生用户获取毕业生登记表
export const getJwReport = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "graduateRegister", {
           data: _params,
           method: "GET",
         });
       };

// 学生 - 提交毕业生登记报表
export const submitReport = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "submitReport", {
           data: _params,
           method: "POST",
         });
       };

// 学生 - 保存毕业生登记报表
export const saveReport = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "saveReport", {
           data: _params,
           method: "POST",
         });
       };



// WEBPACK FOOTER //
// ./src/fetch/api/rollStudent.js